<div [dir]="this.app.getUserDire()">
    <ul class="listSt py-3">

        <!-- edit -->
        <li class="px-4">
            <div class="d-flex pointer" (click)="editPost()">
                <span class="dotCirIcon"><mat-icon class="postIcons">edit</mat-icon></span>
                <p class="postP mx-2">{{ 'social.edit' | translate }}</p>
            </div>
        </li>
        <hr class="greyColor my-3">
        <!-- edit -->

        <!-- anAndIn -->
        <li class="px-4">
            <div class="d-flex pointer" (click)="chartPopUp(postDetails?.postId)">
                <span class="dotCirIcon"><mat-icon class="postIcons">insert_chart_outlined</mat-icon></span>
                <p class="postP mx-2">{{ 'social.anAndIn' | translate }}</p>
            </div>
        </li>
        <hr class="greyColor my-3">
        <!-- anAndIn -->

        <!-- pinTo -->
        <li class="px-4">
            <div class="d-flex pointer" (click)="pinPostAndUnpin()">
                <span class="dotCirIcon"><mat-icon class="postIcons">push_pin</mat-icon></span>
                <p *ngIf="!this?.postDetails?.iPinnedPost" class="postP mx-2">{{ 'social.pinTo' | translate }}</p>
                <p *ngIf="this?.postDetails?.iPinnedPost" class="postP mx-2">{{ 'social.unpinTo' | translate }}</p>
            </div>
        </li>
        <hr class="greyColor my-3">
        <!-- pinTo -->


        <!-- delete -->
        <li class="px-4">
            <div class="d-flex pointer" (click)="deleteMyPost()" >
                <span class="deleteIcon"><mat-icon class="postIcons">delete</mat-icon></span>
                <p class="deleteP mx-2">{{ 'social.delete' | translate }}</p>
            </div>
        </li>
        <hr class="greyColor my-3">
        <!-- delete -->

        <!-- dismiss -->
        <li class="px-4">
            <div class="d-flex pointer" (click)="dismiss()">
                <span class="dotCirIcon"><mat-icon class="postIcons">close</mat-icon></span>
                <p class="postP mx-2">{{ 'social.dismiss' | translate }}</p>
            </div>
        </li>
        <!-- dismiss -->

    </ul>
</div>